import ApiService from "@/services/Api"
import { BoardStage, BoardStageWithoutCards } from "@/services/BoardStage"
import { BoardCardStatus } from "@/services/BoardStageCardService"

export type BoardLossReason = {
	id: number
	reasonText: string
}

export type BoardSettings = {
	isContactValueRequired: boolean
	isResponsibleUserRequired: boolean
}

export const DEFAULT_BOARD_SETTINGS: BoardSettings = {
	isContactValueRequired: false,
	isResponsibleUserRequired: false
}

export type BoardFormattedForList = Omit<Board, "stages">

export type BoardSummary = BoardFormattedForList & {
	stages: Array<BoardStageWithoutCards>
	lossReasons?: Array<BoardLossReason>
	lossOtherEnabled?: boolean
	settings?: BoardSettings
}

export type Board = {
	id: number
	name: string
	description?: string
	createdAt: Date
	updatedAt: Date
	stages: Array<BoardStage>
}

export type CreateBoardInput = {
	name: string
	description?: string
}

type GetAllBoardsWithStagesNoCardsResponse = {
	boards: Array<BoardSummary>
}

type GetOrCreateBoardResponse = {
	boards: Array<BoardFormattedForList>
}

export type ShortBoard = {
	id: number
	stage: {
		id: number
		name: string
	}
}

export const BOARD_CARD_STATUS_TO_LABEL: Record<BoardCardStatus, string> = {
	won: "Ganho",
	lost: "Perdido"
}

class BoardService {
	async create (input: CreateBoardInput): Promise<number> {
		const response = await ApiService.post("/boards", {
			...input
		})

		return response.data.id
	}

	async getOrCreateBoard (): Promise<BoardFormattedForList[]> {
		const response = await ApiService.get<GetOrCreateBoardResponse>("/boards")

		return response.data.boards
	}

	async retrieveAllBoardsWithStagesNoCards () {
		const response = await ApiService.get<GetAllBoardsWithStagesNoCardsResponse>("/boards-with-stages-no-cards")

		return response.data.boards
	}
}

export default new BoardService()
